import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import { PlusCircle, MinusCircle, CreditCard, Ticket, Landmark, ArrowLeftRight, TrendingUp, Settings, ChevronRight } from 'lucide-react';

const services = [
  { label: 'Deposit Funds', desc: 'Add funds via UPI, Bank Transfer & more', icon: PlusCircle, path: '/deposit', color: 'text-emerald-400 bg-emerald-500/15' },
  { label: 'Withdraw Funds', desc: 'Withdraw to bank or UPI', icon: MinusCircle, path: '/withdraw', color: 'text-red-400 bg-red-500/15' },
  { label: 'Leverage Fund', desc: 'View leverage fund & trading volume', icon: TrendingUp, path: '/leverage', color: 'text-blue-400 bg-blue-500/15' },
  { label: 'Trade', desc: 'Buy & sell crypto, forex, indices', icon: CreditCard, path: '/trade', color: 'text-green-400 bg-green-500/15' },
  { label: 'Wallet', desc: 'View wallet balance & transactions', icon: ArrowLeftRight, path: '/wallet', color: 'text-purple-400 bg-purple-500/15' },
  { label: 'Tickets', desc: 'Support & help center', icon: Ticket, path: '/tickets', color: 'text-amber-400 bg-amber-500/15' },
  { label: 'Bank Account', desc: 'Manage linked accounts', icon: Landmark, path: '/bank-accounts', color: 'text-cyan-400 bg-cyan-500/15' },
  { label: 'Settings', desc: 'Profile & preferences', icon: Settings, path: '/profile', color: 'text-zinc-400 bg-zinc-500/15' },
];

export default function ServicesPage() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="max-w-2xl space-y-6" data-testid="services-page">
        <div>
          <h1 className="text-lg font-semibold font-['Outfit'] text-[var(--text-primary)]">Services</h1>
          <p className="text-xs text-[var(--text-secondary)] mt-0.5">Quick access to all platform features</p>
        </div>

        <div className="space-y-3">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <button
                key={s.label}
                onClick={() => navigate(s.path)}
                data-testid={`service-${s.label.toLowerCase().replace(/\s+/g, '-')}`}
                className="w-full flex items-center gap-4 p-4 bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-lg hover:bg-[var(--hover-bg)] transition-all duration-200 group border-l-[3px] border-l-emerald-500/60"
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${s.color}`}>
                  <Icon className="w-5 h-5" />
                </div>
                <div className="flex-1 text-left">
                  <p className="text-sm font-semibold text-[var(--text-primary)]">{s.label}</p>
                  <p className="text-xs text-[var(--text-secondary)]">{s.desc}</p>
                </div>
                <ChevronRight className="w-4 h-4 text-[var(--text-tertiary)] group-hover:text-[var(--text-secondary)] transition-colors" />
              </button>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
}
